import { useState, useMemo } from "react";
import { Box, Typography, Stack, Paper } from "@mui/material";
import { AvailableShipmentItemTable } from "../ShipmentsTable/ShipmentsLogsDrawer/AvailableShipmentTable/AvailableShipmentTable";
import {
  itemColumnDefs,
  quoteColumnDefs,
} from "../ShipmentsTable/ShipmentsLogsDrawer/AvailableShipmentTable/AvailableShipmentLogsColumnDefs";
import { CardWithCollapse } from "../CardWithCollapse/CardWithCollapse";
import { AusPostIcon, InhouseParcelIcon } from "../Icon";
import { globalTheme } from "../../styles";

export const ShipmentAvailableQuotes = ({ data }) => {
  const [expandedCard, setExpandedCard] = useState<number | null>(null);

  // Access the first item if applicable
  const shipmentLogs = data.availableQuotes;

  const shipments = useMemo(() => {
    return [
      {
        id: 1,
        title: (
          <Stack direction="row" gap={1}>
            <AusPostIcon />
            <Typography>eParcel</Typography>
          </Stack>
        ),
        items: shipmentLogs?.EPARCEL?.items,
        quotes: shipmentLogs?.EPARCEL?.carrierQuotes,
      },
      {
        id: 2,
        title: (
          <Stack direction="row" gap={1}>
            <img src="https://www.directfreight.com.au/images/logo.gif" width="30px" height="24px" />
            <Typography>Direct Freight</Typography>
          </Stack>
        ),
        items: shipmentLogs?.DIRECTFREIGHT?.items,
        quotes: shipmentLogs?.DIRECTFREIGHT?.carrierQuotes,
      },
      {
        id: 3,
        title: (
          <Stack direction="row" gap={1}>
            <img
              src="https://vtlogo.com/wp-content/uploads/2021/02/fastway-couriers-vector-logo.png"
              width="30px"
              height="24px"
            />
            <Typography>MyFastway</Typography>
          </Stack>
        ),
        items: shipmentLogs?.MYFASTWAY?.items,
        quotes: shipmentLogs?.MYFASTWAY?.carrierQuotes,
      },
      {
        id: 4,
        title: (
          <Stack direction="row" gap={1}>
            <InhouseParcelIcon />
            <Typography>InhouseParcel</Typography>
          </Stack>
        ),
        items: shipmentLogs?.INHOUSE?.items,
        quotes: shipmentLogs?.INHOUSE?.carrierQuotes,
      },
    ].filter((shipment) => shipment.items?.length || shipment.quotes?.length);
  }, [shipmentLogs]);

  const handleExpandClick = (id: number) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <Box>
      <Typography
        sx={{
          backgroundColor: globalTheme.background,
          color: globalTheme.primaryColor,
          p: 1,
          borderRadius: 2,
          width: "fit-content",
          mb: 2,
        }}
        variant="body2"
      >
        OrderID:{data.orderIds}
      </Typography>

      {shipments.map((shipment) => (
        <Box key={shipment.id} mb={3}>
          {/* TODO: We can simply use Accordion component instead of custom building components - CardWithCollapse - @sai */}
          <CardWithCollapse
            title={shipment.title}
            isExpanded={expandedCard === shipment.id}
            onToggle={() => handleExpandClick(shipment.id)}
          >
            <Stack spacing={2}>
              <Paper elevation={3} sx={{ padding: 2 }}>
                <Typography
                  sx={{
                    backgroundColor: globalTheme.background,
                    color: globalTheme.primaryColor,
                    p: 1,
                    borderRadius: 2,
                    width: "fit-content",
                    mb: 1,
                  }}
                  variant="body1"
                >
                  Items
                </Typography>
                <AvailableShipmentItemTable rows={shipment.items} columnDefs={itemColumnDefs} />
              </Paper>
              <Paper elevation={3} sx={{ padding: 2 }}>
                <Typography
                  sx={{
                    backgroundColor: globalTheme.background,
                    color: globalTheme.primaryColor,
                    p: 1,
                    borderRadius: 2,
                    width: "fit-content",
                    mb: 1,
                  }}
                  variant="body1"
                >
                  Available Quotes
                </Typography>
                <AvailableShipmentItemTable rows={shipment.quotes} columnDefs={quoteColumnDefs} />
              </Paper>
            </Stack>
          </CardWithCollapse>
        </Box>
      ))}
    </Box>
  );
};
